import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from '@/components/ScrollToTop';
import { Home } from '@/pages/Home';
import { Privacy } from '@/pages/Privacy';
import { Terms } from '@/pages/Terms';
import { FairUse } from '@/pages/FairUse';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacidad" element={<Privacy />} />
        <Route path="/terminos" element={<Terms />} />
        <Route path="/fair-use" element={<FairUse />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
